/**
 * Created by USER on 2018/11/7.
 */
export const GET_ANNOUNCEMENT = 'GET_ANNOUNCEMENT'; // 公告列表
export const GET_SINGLE_ANNOUNCEMENT = 'GET_SINGLE_ANNOUNCEMENT'; // 单个公告的内容


export function getAnnouncement(data) {
  return {
    type: GET_ANNOUNCEMENT,
    data
  };
}

export function getSingleAnnouncement(data) {
  return {
    type: GET_SINGLE_ANNOUNCEMENT,
    data
  };
}